module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.titulo
    }
  }, [(_vm.filePath) ? _c('span', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.filePath,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n      ")])]) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('el-upload', {
    ref: "refFile",
    staticClass: "upload-demo",
    attrs: {
      "v-if": _vm.habModificaPdf,
      "id": _vm.id,
      "action": _vm.serverURI + 'api/uploadPdfFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdf,
      "on-exceed": _vm.handleExceed,
      "on-remove": _vm.handleRemove,
      "show-file-list": false,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 0
    }
  }, [(_vm.habModificaPdf) ? _c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]) : _vm._e(), _vm._v(" "), (_vm.fileName) ? _c('el-button', {
    attrs: {
      "size": "small",
      "enable": "false",
      "type": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.fileName ? _vm.fileName + ".pdf" : "-"))]) : _vm._e(), _vm._v(" "), (_vm.filePath && _vm.habModificaPdf) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.removePdf
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.habModificaPdf && !_vm.disabled) ? _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Solo se permiten archivos PDF")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f3327f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PdfFile.vue
// module id = 645
// module chunks = 1